import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Tooltip } from '@systemeio/ui'
import PricePlanTooltip from 'modules/digital-product/price-plans/components/price-plan-tooltip'
import { PricePlanType } from '@systemeio/types'
import React, { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { BinIcon, ChangeIcon, DragIcon, SettingsIcon } from '@systemeio/ui'

interface PricePlanItemProps {
  pricePlan: PricePlanType
  onChange: () => void
  onEdit: () => void
  onDelete: () => void
}

const animateLayoutChanges: AnimateLayoutChanges = args =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true })
const PricePlanItem: FC<PricePlanItemProps> = ({ pricePlan, onChange, onEdit, onDelete }) => {
  const { t } = useLocoTranslation()
  const { attributes, listeners, setNodeRef, isDragging, transform } = useSortable({
    id: pricePlan.id,
    animateLayoutChanges,
  })

  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : undefined,
  }

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={'flex items-center gap-3'}
      style={dndStyle}
    >
      <DragIcon />
      <div className="border-text-secondary/30 flex w-full items-center justify-between rounded-lg border p-2">
        <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3">
          <PricePlanTooltip
            pricePlan={pricePlan}
            label={
              <div className="text-brand-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]">
                <span>{pricePlan.innerName || 'test.price.plan.name'}</span>
              </div>
            }
          />
        </div>
        <div className="flex items-center gap-2">
          <Tooltip
            mode={'hover'}
            label={t('dashboard.funnel.configuration.common.price_plan.change_title')}
          >
            <ChangeIcon
              className="hover:fill-text-primary h-[16px] w-[17px] cursor-pointer fill-[rgb(var(--fill-primary))]"
              onClick={onChange}
            />
          </Tooltip>
          <Tooltip
            mode={'hover'}
            label={t('dashboard.funnel.configuration.common.price_plan.edit_title')}
          >
            <SettingsIcon
              className="hover:fill-text-primary h-[16px] w-[17px] cursor-pointer fill-[rgb(var(--fill-primary))]"
              onClick={onEdit}
            />
          </Tooltip>
          <BinIcon className="h-[18px] w-[17px] cursor-pointer" onClick={onDelete} />
        </div>
      </div>
    </div>
  )
}

export default PricePlanItem
